<template>
    <div class="container">

        <section class="top-cat">
            <div class="container">

<!--                <h1>{{countryMain1}}</h1>-->

                <div v-if="countryMain === 1" class="row">

                    <div class="col-md-12" v-if="lang === 'en'">
                        <h1>Terms and Conditions</h1>
                        <h3 align="left">Collecting Points</h3>
                        <p align="left">
                            •	After Waffir Registration the Account will be activated within 24 hours.

                            <br/>•	To collect your points, your Waffir Account must be activated.

                            <br/>•	Minimum eligible Amount to earn points is 15 Saudi Riyal per transaction.

                            <br/>•	With every Saudi Riyal spent, you will collect one point that gets credited to your Waffir account within 24 hours from the transaction time.

                            <br/>•	For every 100 Points you earn, you get 2 Saudi Riyal for redemption.

                            <br/>•	Points can be collected on all items purchased from the Prime Markets.

                            <br/>•	You can claim transaction points that has not been added to your Waffir account within one week from the transaction date by using the transaction receipt? How He can claim?

                            <br/>•	Points can be collected during promotions.

                            <br/>•	Points can’t be collected on redeemed points with transactions paid for in full or partially using redemptions.

                            <br/>•	New Points Will Be Calculated based on Without VAT amount.


                        </p>

                        <h3 align="left">Redeeming Points</h3>
                        <p align="left">
                            •	To redeem your points, your Waffir Account must be activated.

                            <br/>•	Once you reach 5000 Points, you will be eligible for redemption.

                            <br/>•	To better serve you, you are kindly required to redeem your acquired cash in a period not exceeding 24 months from the date of the transaction.

                        </p>

                        <h3 align="left">General Information</h3>
                        <p align="left">
                            •	Prime Markets reserve the rights to cancel the membership or the credit without prior notice to the customer.

                            <br/>•	Your use of the card will express your agreement to the terms and conditions, and Prime Markets reserve the right to change the terms and conditions without prior notice to the customer.

                            <br/>•	The customer is not allowed to use more than 1 card.

                            <br/>•	The earned points will be expired by 24 months from the date of transaction.

                            <br/>•	The WAFFIR Card Is Not Valid for the Whole Sale Customer. If any Whole Sale Customer try to use the card Prime Markets has the right to cancel the card and points at any given time.

                            <br/>•	Wholesale customers or shop owners are not allowed to use the card, only for home customers.

                        </p>
                    </div>

                    <div class="col-md-12" v-if="lang === 'ar'">
                        <h1>الشروط والأحكام</h1>
                        <h3 align="right">تجميع النقاط</h3>
                        <p align="right">
                            <br/> بعد التسجيل بـ وفر سيتم تفعيل الحساب في خلال 24 ساعة

                            <br/>لتبدأ في تجميع نقاطك يجب أن يكون حسابك بـ وفر مفعل

                            <br/>الحد الأدنى الذي يؤهلك لإحتساب النقاط هو 15 ريال سعودي لكل عملية شراء

                            <br/>لكل واحد ريال سعودي تنفقه سوف تُحسب نقطة واحدة يتم إضافتها لحسابك بـ وفر في خلال 24 ساعة من وقت عملية الشراء

                            <br/>مقابل كل 100 نقطة مكتسبة سيتم الحصول على 2 ريال سعودي للإستبدال

                            <br/>يمكن جمع النقاط على جميع المواد المشتراة من أسواق النخبة

                            <br/>يمكنك المطالبة بالنقاط التي لم يتم إضافتها الى حسابك بـ وفر في خلال واحد اسبوع من تاريخ العملية الشرائية باستخدام الفاتورة  كيف يمكن القيام بذلك؟

                            <br/>يمكن جمع النقاط خلال العروض الترويجية

                            <br/>لا يمكن جمع النقاط على عمليات الشراء المدفوعة جزئياً أو كلياً باستخدام النقود المكتسبة من عملية إستبدال النقاط

                            <br/>سيتم احتساب النقاط الجديدة بناءً على مبلغ الفاتورة بدون احتساب القيمة المضافة


                        </p>

                        <h3 align="right">إستبدال النقاط </h3>
                        <p align="right">

                            <br/>لتقم باستبدال نقاطك يجب أن يكون حسابك بـ وفر مفعل

                            <br/>عند وصولك الى 5000 نقطة ستكون مؤهلا لإستبدال نقاطك

                            <br/>لخدمتك بشكل أفضل, نرجوا منك صرف رصيدك من النقود المكتسبة في فترة لا تتجاوز 24 شهراً من تاريخ عملية الشراء

                        </p>

                        <h3 align="right">معلومات عامة</h3>
                        <p align="right">
                            <br/>أسواق النخبة تحتفظ بحقها في إلغاء العضوية أو الرصيد دون إشعار مسبق للعميل

                            <br/>إستخدامك للبطاقة يدل على موافقتك على الشروط والأحكام, تحتفظ أسواق النخبة بحقها في تغيير الشروط والأحكام دون إشعار مسبق للعميل

                            <br/>لا يُسمح للعميل باستخدام أكثر من بطاقة واحدة

                            <br/>سوف تنتهي صلاحية النقاط المكتسبة بعد مرور 24 شهراً من تاريخ عملية الشراء

                            <br/>لايسمح لعملاء الجملة او اصحاب المحلات استخدام البطافة , فقط لعملاء المنزل


                        </p>

                    </div>


                    <div class="align-content-center align-middle" align="center" style="margin-left: 300px; margin-right: 300px; align-content: center !important; text-align: center !important;">
                        <img align="center" style="align-content: center !important;  text-align: center !important;" class="align-middle" src="/static/terms.JPG">
                    </div>
                </div>


                <div v-if="countryMain === 19" class="row">

                    <div class="col-md-12" v-if="lang === 'en'">
                        <h1>Terms and Conditions - Bahrain</h1>
                        <h3 align="left">Collecting Points</h3>
                        <p align="left">
                            •	After Waffir Registration the Account will be activated within 24 hours.
                            <br/> •	To collect your points, your Waffir Account must be activated.
                            <br/> •	Minimum eligible Amount to earn points is 1.5 Bharani Dinar per transaction.
                            <br/> •	With every 100 Fills you spent, you will collect one point that gets credited to your Waffir account within 24 hours from the transaction time.
                            <br/> •	For every 100 Points you earn, you get 200 Fills for redemption.
                            <br/> •	Points can be collected on all items purchased from the Prime Markets.
                            <br/> •	You can claim transaction points that has not been added to your Waffir account within one week from the transaction date by using the transaction receipt.
                            <br/> •	Points can be collected during promotions.
                            <br/> •	Points can’t be collected on redeemed points with transactions paid for in full or partially using redemptions.


                        </p>

                        <h3 align="left">Redeeming Points</h3>
                        <p align="left">
                            •	To redeem your points, your Waffir Account must be activated.
                            <br/> •	Once you reach 5000 Points, you will be eligible for redemption.
                            <br/> •	To better serve you, you are kindly required to redeem your acquired cash in a period not exceeding 24 months from the date of the transaction.

                        </p>

                        <h3 align="left">General Information</h3>
                        <p align="left">
                            •	Prime Markets reserve the rights to cancel the membership or the credit without prior notice to the customer.
                            <br/> •	Your use of the card will express your agreement to the terms and conditions, and Prime Markets reserve the right to change the terms and conditions without prior notice to the customer.
                            <br/> •	The customer is not allowed to use more than 1 card.
                            <br/> •	The earned points will be expired by 24 months from the date of transaction.
                            <br/> •	The WAFFIR Card Is Not Valid for the Whole Sale Customer. If any Whole Sale Customer try to use the card Prime Markets has the right to cancel the card and points at any given time.
                            <br/> •	Wholesale customers or shop owners are not allowed to use the card, only for home customers.


                        </p>
                    </div>

                    <div class="col-md-12" v-if="lang === 'ar'">
                        <h1>الشروط والأحكام</h1>
                        <h3 align="right">تجميع النقاط</h3>
                        <p align="right">
                            <br/> •	بعد التسجيل بـ وفر سيتم تفعيل الحساب في خلال 24 ساعة.
                            <br/> •	لتبدأ في تجميع نقاطك يجب أن يكون حسابك بـ وفر مفعل.
                            <br/> •	الحد الأدنى الذي يؤهلك لإحتساب النقاط هو 1.5 دينار بحريني لكل عملية شراء.
                            <br/> •	لكل 100 فلس تنفقه سوف تُحسب نقطة واحدة يتم إضافتها لحسابك بـ وفر في خلال 24 ساعة من وقت عملية الشراء.
                            <br/> •	مقابل كل 100 نقطة مكتسبة سيتم الحصول على 200 فلس بحريني للإستبدال.
                            <br/> •	يمكن جمع النقاط على جميع المواد المشتراة من أسواق النخبة.
                            <br/> •	يمكنك المطالبة بالنقاط التي لم يتم إضافتها الى حسابك بـ وفر في خلال واحد اسبوع من تاريخ العملية الشرائية باستخدام الفاتورة.  كيف يمكن القيام بذلك؟
                            <br/> •	يمكن جمع النقاط خلال العروض الترويجية.
                            <br/> •	لا يمكن جمع النقاط على عمليات الشراء المدفوعة جزئياً أو كلياً باستخدام النقود المكتسبة من عملية إستبدال النقاط.

                        </p>

                        <h3 align="right">إستبدال النقاط </h3>
                        <p align="right">

                            <br/> •	لتقم باستبدال نقاطك يجب أن يكون حسابك بـ وفر مفعل.
                            <br/> •	عند وصولك الى 5000 نقطة ستكون مؤهلا لإستبدال نقاطك.
                            <br/> •	لخدمتك بشكل أفضل, نرجوا منك صرف رصيدك من النقود المكتسبة في فترة لا تتجاوز 24 شهراً من تاريخ عملية الشراء.


                        </p>

                        <h3 align="right">معلومات عامة</h3>
                        <p align="right">
                            <br/> •	أسواق النخبة تحتفظ بحقها في إلغاء العضوية أو الرصيد دون إشعار مسبق للعميل.
                            <br/> •	إستخدامك للبطاقة يدل على موافقتك على الشروط والأحكام, تحتفظ أسواق النخبة بحقها في تغيير الشروط والأحكام دون إشعار مسبق للعميل.
                            <br/> •	لا يُسمح للعميل باستخدام أكثر من بطاقة واحدة.
                            <br/> •	سوف تنتهي صلاحية النقاط المكتسبة بعد مرور 24 شهراً من تاريخ عملية الشراء.
                            <br/> •	لايسمح لعملاء الجملة او اصحاب المحلات استخدام البطافة , فقط لعملاء المنزل.

                        </p>

                    </div>

                </div>



            </div>
        </section>


    </div>
</template>
<script>
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        data () {
            return {
                // countryMain: this.$store.getters['environment/getCountryMain'],
            }
        },
        computed: {
            auth () {
                return this.$store.getters['auth/isAuthenticated']
            },
            balance () {
                return this.$store.getters['account/getBalance']
            },
            countryMain1 () {
                return this.$store.getters['environment/getCountryMain']
            },
        },
        methods: {
            onLogout() {
                this.$store.dispatch('auth/logout')
            }
        }
    }
</script>
<style>
    /*@import url("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css");*/
</style>


// WEBPACK FOOTER //
// src/components/website/terms.vue